import { setServices, setMessage } from '../store/actions'

export const SLUG_TO_SERVICE_NAME = {
  exterior_wash_and_wax: 'Exterior Wash & Wax',
  mini_valet: 'Mini Valet',
  mini_valet_plus: 'Mini Valet PLUS',
  dog_owners_valet: 'Dog Owners Valet',
  full_valet: 'Full Valet',
  interior_only_valet: 'Interior Only Valet'
}

// Format a list of names as "A", "A and B", or "A, B, and C".
const joinNames = names => {
  if (names.length === 1) return names[0]
  if (names.length === 2) return `${names[0]} and ${names[1]}`
  return `${names.slice(0, -1).join(', ')}, and ${names[names.length - 1]}`
}

export const applyServiceSlug = (slug, { prices, services, dispatch }) => {
  const targetName = SLUG_TO_SERVICE_NAME[slug]
  if (!targetName || !prices?.byId) return null

  const baseService = Object.values(prices.byId).find(s => s.name === targetName)
  if (!baseService) return null

  // Zero ALL base services explicitly before setting the chosen one. We can't
  // rely on each base's `excludes` array correctly listing every other base -
  // that's fragile if the data drifts and was the cause of "switching wash
  // doesn't update" bugs.
  const allBaseIds = Object.values(prices.byId)
    .filter(s => s.group === 'base')
    .map(s => s.id)

  // Any extras the user previously paid for that are now bundled into the new
  // base - auto-deselect them so we don't double-charge. Track names so we
  // can tell the user what was removed.
  const includedIds = baseService.includes || []
  const removedExtraNames = includedIds
    .filter(id => services[id] === true)
    .map(id => prices.byId[id]?.name)
    .filter(Boolean)

  const selectedServices = {
    ...services,
    ...(baseService.excludes || []).reduce((acc, id) => ({ ...acc, [id]: false }), {}),
    ...allBaseIds.reduce((acc, id) => ({ ...acc, [id]: false }), {}),
    ...includedIds.reduce((acc, id) => ({ ...acc, [id]: false }), {}),
    [baseService.id]: true
  }

  const servicesAvailability = Object.values(prices.byId).reduce((acc, service) => {
    return { ...acc, [service.id]: !(baseService.includes || []).includes(service.id) }
  }, {})

  dispatch(setServices({ services: selectedServices, servicesAvailability }))

  if (removedExtraNames.length > 0) {
    dispatch(setMessage(
      `${baseService.name} already includes ${joinNames(removedExtraNames)} - removed from your order.`,
      5000
    ))
  }

  return baseService
}
